module.exports = __webpack_public_path__ + "static/07-f12f3b649abdb4294218463cacf1f2fd.jpg";